const serviceCategoriesHandler = () => {
  const categoryNav = document.querySelector(
    ".service-archive__nav-buttons-wrapper"
  );

  if (categoryNav) {
    const navItem = categoryNav.querySelectorAll(".service-archive__nav-item");

    const url = window.location;

    navItem.forEach((navItem) => {
      const slug = navItem.dataset.slug;

      if (url.href.includes(slug) && slug != "services") {
        navItem.classList.add("active");
      }

      if (`/${navItem.dataset.slug}/` === url.pathname) {
        navItem.classList.add("active");
      }
    });
  }
};

if (document.readyState !== "loading") {
  serviceCategoriesHandler();
} else {
  document.addEventListener("DOMContentLoaded", serviceCategoriesHandler);
}
